export const topArticles = {
  // account and billing
  '115000867647': [
    '115000976672',
    '13502982552347',
    '115005231648',
    '115005062267',
    '360026617692',
  ],
  // analytics
  '115000874048': [
    '1260804504250',
    '115005076767',
    '115005247808',
    '4708299478427',
    '4416172774939',
  ],
  // audience
  '115000867867': [
    '115005247088',
    '360037101072',
    '115005237908',
    '115005251128',
    '360000407272',
  ],
  // campaigns
  '115000867667': [
    '115005054847',
    '360040039971',
    '360006653972',
    '4408802648731',
    '4412748537627',
    '115005082787',
  ],
  // cdp
  '18073014919195': [
    '17655007276059',
    '17798009376155',
    '17797889315355',
    '17797865070235',
    '17760400736539',
    '17759932376475',
    '17760478970907',
  ],
  // content
  '4414879524891': [
    '115005084727',
    '115006155388',
    '115005246547',
    '360041971851',
    '360022884472',
    '360031279471',
  ],
  // conversations
  '14234163769755': [
    '360059002271',
    '34158391513627',
    '34158785231515',
    '4405329314331',
  ],
  // customer hub
  '34141283979931': [
    '33660324811675',
    '33660382797595',
    '33660482389659',
    '33660517680795',
    '33660391549211',
  ],
  // deliverability and compliance
  '115000873988': [
    '115005247008',
    '115000201131',
    '115005078347',
    '115000357752',
    '4404203889947',
    '360025945671',
  ],
  // flows
  '115000312411': [
    '115002774932',
    '360049924272',
    '115002775172',
    '115002779411',
    '115002775252',
    '360051612551',
    '115001396711',
  ],
  // integrations
  '115000032731': [
    '115005080407',
    '115005255808',
    '115005254348',
    '6202669053723',
    '6353315757211',
    '115005082127',
    '115005254948',
  ],
  // reviews
  '16638219724187': [
    '15937542819355',
    '16685026123035',
    '16681935355163',
    '16691200391579',
  ],
  // sign up forms
  '360000190711': [
    '360026474752',
    '360002049952',
    '4413550187035',
    '4413537049883',
    '4413544555547',
    '115005251848',
    '360035056972',
  ],
  // sms
  '29173800271259': [
    '4404274419355',
    '360035056972',
    '360035428731',
    '6637671573403',
    '360036122291',
    '4402914866843',
  ],
};
